import { Box, Stack } from '@mui/material';
import moment from 'moment';
import { useNavigate } from 'react-router-dom';

import { INotification, serverNotificationType } from '@/api/notifications/types';
import { useMarkNotificationAsRead } from '@/api/notifications/use-mark-notification-as-read';
import CloseBtn from '@/assets/svg/ui-elements/close.svg';
import { Button, IconButton, Modal, Typography } from '@/design-system';
import { useGlobalModal } from '@/global-hooks/use-global-modal';
import { PagePaths } from '@/routes/page-paths';

export type NotificationModalProps = {
  data: INotification;
};

export const NotificationModal = () => {
  const { open, handleClose, props } = useGlobalModal('NOTIFICATION_MODAL');
  const navigate = useNavigate();

  const isNewOffer = props?.data.type === serverNotificationType.FOLLOWED_COMPANY_NEW_OFFER;
  const hasOfferLink =
    isNewOffer && props?.data.metadata?.companyId && props?.data.metadata?.offerId;

  const { mutate: readNotification, isPending } = useMarkNotificationAsRead({
    onSuccess: () => {
      handleClose();
      if (hasOfferLink) {
        navigate(
          PagePaths.dealsOfferView
            .replace(':companyId', props!.data.metadata.companyId!)
            .replace(':offerId', props!.data.metadata.offerId!),
        );
      }
    },
  });

  const markAsRead = () => {
    readNotification(props?.data.id as string);
  };

  return (
    <Modal
      open={open}
      onOpenChange={(next) => {
        if (!next) handleClose();
      }}
      maxWidth={380}
    >
      <>
        <Box p="0px 14px" mb="55px">
          <Stack
            direction="row"
            justifyContent="space-between"
            alignItems="flex-start"
            gap="12px"
            mb="10px"
          >
            <Typography
              variant="h6"
              fontWeight={700}
              style={{ flex: 1, minWidth: 0, wordBreak: 'break-word' }}
            >
              {props?.data.title}
            </Typography>
            <IconButton
              aria-label="Close"
              color="secondary"
              variant="subtle"
              size="xs"
              roundness="round"
              onClick={handleClose}
            >
              <CloseBtn />
            </IconButton>
          </Stack>
          <Typography variant="body3" style={{ marginBottom: '11px' }}>
            {props?.data.message}
          </Typography>
          <Typography variant="body4" fontWeight={500} style={{ opacity: 0.4 }}>
            {props?.data?.createdAt ? moment(props.data.createdAt).format('DD.MM.YYYY') : ''}
          </Typography>
        </Box>
        <Button size="xl" fullWidth onClick={markAsRead} loading={isPending}>
          {hasOfferLink ? 'View Offer' : 'Mark as Read'}
        </Button>
      </>
    </Modal>
  );
};
